export default {
    methods: {
		// 获取拓展框验证
		getPlaceholder(rule, minLength, maxLength ) {
			switch( rule ){
				case 'number':
					if( 
						minLength !== undefined && 
						minLength !== null &&
						minLength !== "" &&
						minLength >= 0 && 
						maxLength !== undefined && 
						maxLength !== null &&
						maxLength !== "" && 
						maxLength >= 0
					) {
						return `请填写数字，值为${minLength}到${maxLength}`
					}
					if( 
						minLength !== undefined && 
						minLength !== null && 
						minLength !== "" && 
						minLength >= 0 
					) {
						return `请填写大于${minLength}的数字`
						
					}
					if( 
						maxLength !== undefined && 
						maxLength !== null && 
						maxLength !== "" && 
						maxLength >= 0
					) {
						return `请填写小于${maxLength}的数字`
					}
					return '请填写数字'

				case 'email':
					return '请填写邮箱'
				case 'phone':
					return '请填写手机号'
				default: 
					return '请输入'
			}
		}
	}
}